import React from 'react';
import styled from 'styled-components';
import {useOutlet, useOutletSetter} from 'reconnect.js';
import {message} from 'antd';
import nft from '../../Utils/Nft';
import * as AppActions from '../../AppActions';
import BaseSection from '../../Components/BaseSection';
import Constants from '../../Constants';
import moment from 'moment';

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function MintPage(props) {
  // don't remove it, use it to listen for update
  useOutlet('update-counter');
  const [contractInfo, setContractInfo] = React.useState(null);
  const setUpdateCnt = useOutletSetter('update-counter');
  const [number, setNumber] = React.useState(1);
  const MINT_INFO = props.mintInfo || {};
  const [errMsg, setErrMsg] = React.useState(null);
  const [isMintSuccess, setIsMintSuccess] = React.useState(false);

  React.useEffect(() => {
    async function loadRequiredContractInfo() {
      AppActions.setLoading(true);

      try {
        const name = await nft.getName();
        const price = await (MINT_INFO.phase === 0
          ? nft.getWhiteListPrice()
          : nft.getPrice());
        const mintCountHistory = await nft.getMintCountHistory();
        const startTime = await (MINT_INFO.phase === 0
          ? nft.getWhiteListSaleStartTime()
          : nft.getSaleStartTime());
        const endTime = await (MINT_INFO.phase === 0
          ? nft.getWhiteListSaleEndTime()
          : nft.getSaleEndTime());

        await nft.loadFullContractInfo();
        const maxBalanceForOneAddress = parseInt(nft.maxBalance);
        const maxMintOneTime = parseInt(nft.maxMint);

        const _c = {
          name,
          price,
          mintCountHistory,
          startTime,
          endTime,
          startTimeUTC: moment
            .unix(startTime)
            .utc()
            .format('YYYY-MM-DD HH:mm:ss (UTC)'),
          endTimeUTC: moment
            .unix(endTime)
            .utc()
            .format('YYYY-MM-DD HH:mm:ss (UTC)'),
          maxBalanceForOneAddress,
          maxMintOneTime,
        };

        setContractInfo(_c);
        console.log(
          MINT_INFO.phase === 0 ? '[ official ]' : 'public phase',
          _c,
        );
      } catch (err) {
        console.error(err);
        nft.disconnect();
        setUpdateCnt((cnt) => cnt + 1);
        window.alert(
          'Connect Fail ! Please check the network status (Ethereum Mainnet) or Restart your metamask !',
        );
      }
      AppActions.setLoading(false);
    }

    loadRequiredContractInfo();
  }, []);

  function partialAddress(address) {
    const head = address.substring(0, 8);
    const end = address.substring(address.length - 8, address.length);
    return head + '...' + end;
  }

  const doMint = async () => {
    setErrMsg(null);
    setIsMintSuccess(false);
    AppActions.setLoading(true);
    if (MINT_INFO.phase === 1) {
      /* public mint */
      await nft.mint(number, (s) => setIsMintSuccess(s), setErrMsg);
    } else if (MINT_INFO.phase === 0) {
      /* merkle mint */

      const merkleProofs = await nft.getMerkleProofs();
      if (merkleProofs) {
        await nft.merkleProofMint(
          number,
          merkleProofs,
          (s) => setIsMintSuccess(s),
          setErrMsg,
        );
      } else {
        window.alert('Error ! Not in whitelist');
      }
    }
    AppActions.setLoading(false);

    setUpdateCnt((cnt) => cnt + 1);
  };

  const getTotalPrice = (unit, number) => {
    return (unit * number).toFixed(3);
  };

  return contractInfo ? (
    <Wrapper>
      <p
        onClick={() => {
          nft.disconnect();
          setErrMsg(null);
          setIsMintSuccess(false);
          setUpdateCnt((cnt) => cnt + 1);
        }}
        style={{
          cursor: 'pointer',
          backgroundColor: 'lightgrey',
          padding: '10px 20px 10px 20px',
          display: 'inline-block',
          color: 'white',
          borderRadius: 20,
          textShadow: 'black 0.1em 0.1em 0.2em',

          textAlign: 'center',
          verticalAlign: 'middle',
          borderColor: 'white',
          borderWidth: 2,
          borderStyle: 'solid',
        }}>
        Disconnect
      </p>
      <p
        style={{
          marginTop: 50,
          fontWeight: 'bold',
          fontSize: '2rem',
          lineHeight: '50%',
          color: 'white',
        }}>
        {MINT_INFO.phase === 0 ? '[System]' : 'Public Mint'}
      </p>
      <p
        style={{
          marginTop: 10,
          fontWeight: 'bold',
          fontSize: '1rem',
          lineHeight: '50%',
          color: 'white',
        }}>
        FROM: {contractInfo.startTimeUTC}
      </p>
      <p
        style={{
          marginTop: 20,
          fontWeight: 'bold',
          fontSize: '1rem',
          lineHeight: '50%',
          color: 'white',
        }}>
        TO: {contractInfo.endTimeUTC}
      </p>

      <p style={{marginTop: 10, fontSize: '1rem'}}>
        {partialAddress(nft.account)}
      </p>

      <InputNumber
        min={1}
        max={contractInfo.maxMintOneTime - contractInfo.mintCountHistory}
        onChange={(n) => setNumber(n)}
      />
      <p style={{marginTop: 10, fontSize: '1rem'}}>
        {getTotalPrice(Number(contractInfo.price) / Math.pow(10, 18), number)}
        ETH
      </p>
      <p
        onClick={
          /*
          contractInfo.mintCountHistory >= contractInfo.maxMintOneTime
            ? () => 0
            :*/ doMint
        }
        style={{
          cursor:
            /*contractInfo.mintCountHistory >= contractInfo.maxMintOneTime
              ? 'not-allowed'
              :*/ 'pointer',
          backgroundColor:
            /*contractInfo.mintCountHistory >= contractInfo.maxMintOneTime
              ? 'grey'
              :*/ '#69EFFF',
          padding: '10px 20px 10px 20px',
          display: 'inline-block',
          color:
            /*contractInfo.mintCountHistory >= contractInfo.maxMintOneTime
              ? 'black'
              :*/ 'white',
          borderRadius: 20,
          maxWidth: 400,
          width: '40%',
          textShadow: 'black 0.1em 0.1em 0.2em',

          textAlign: 'center',
          verticalAlign: 'middle',
          borderColor: 'white',
          borderWidth: 2,
          borderStyle: 'solid',
        }}>
        Mint
      </p>
      {errMsg && (
        <p
          style={{
            maxWidth: 800,
            minWidth: 200,
            width: '100%',
            color: '#413543',
            backgroundColor: '#E49393',
            borderRadius: 5,
            padding: 5,
            textAlign: 'center',
            cursor: 'copy',
          }}
          onClick={() =>
            window.navigator.clipboard.writeText(
              errMsg.txHash || JSON.stringify(errMsg),
            )
          }>
          {errMsg.txHash
            ? '[Click To Copy]\nPlease Check txHash:\n' + errMsg.txHash
            : JSON.stringify(errMsg)}
        </p>
      )}
      {isMintSuccess && (
        <p
          style={{
            maxWidth: 800,
            minWidth: 200,
            width: '100%',
            color: '#ffffff',
            backgroundColor: '#EBB02D',
            borderRadius: 5,
            padding: 5,
            textAlign: 'center',
            cursor: 'copy',
          }}>
          Congratulations! You have successfully completed NFT minting.
        </p>
      )}
    </Wrapper>
  ) : (
    <div />
  );
  /*

  const {
    pageContext: {whiteList = false},
  } = props;
  const [contractInfo, setContractInfo] = React.useState(null);
  const [txHash, setTxHash] = React.useState(null);
  const quantityInputRef = React.useRef();

  React.useEffect(() => {
    async function loadRequiredContractInfo() {
      AppActions.setLoading(true);
      if (whiteList) {
        setContractInfo({
          maxMint: await nft.getMaxMint(),
          tierSupply: await nft.getWhiteListTierSupply(),
          saleStartTime: await nft.getWhiteListSaleStartTime(),
          saleEndTime: await nft.getWhiteListSaleEndTime(),
        });
      } else {
        setContractInfo({
          maxMint: await nft.getMaxMint(),
          tierSupply: await nft.getTierSupply(),
          saleStartTime: await nft.getSaleStartTime(),
          saleEndTime: await nft.getSaleEndTime(),
        });
      }
      AppActions.setLoading(false);
    }

    loadRequiredContractInfo();
  }, [whiteList]);

  async function onMintClick() {
    if (!nft.account) {
      alert('請先連線您的MetaMask錢包');
      return;
    }

    const elem = quantityInputRef.current;
    const value = parseInt(elem.options[elem.selectedIndex].value);

    AppActions.setLoading(true);
    await delay(500);
    try {
      let resp;
      if (whiteList) {
        resp = await nft.whiteListMint(value);
      } else {
        resp = await nft.mint(value);
      }
      if (resp) {
        message.success('成功');
        setTxHash(resp.transactionHash);
      }
    } catch (ex) {
      console.warn(ex);
    }
    AppActions.setLoading(false);
  }

  const inputDisabled = !!txHash;

  return (
    <Wrapper id="mint-page">
      <Navbar hideButtons />

      {contractInfo && (
        <HeroSection>
          <div className="content">
            <figure>
              <img src={Constants.mintLogo} alt="mct" />
            </figure>

            <div style={{flex: '0 0 20px'}} />

            <div>
              {!nft.account ? (
                <h2>{'Not Connected'}</h2>
              ) : (
                <h2>{whiteList ? 'White List Mint' : 'Mint'}</h2>
              )}

              {nft.account && (
                <>
                  <CurrMintTime nft={contractInfo}>
                    <div style={{color: 'white', marginBottom: 30}}>
                      <CurrMintSupply nft={contractInfo} />
                    </div>

                    <select ref={quantityInputRef} disabled={inputDisabled}>
                      {Array.from({
                        length: contractInfo.maxMint,
                      })
                        .map((_, idx) => ({value: idx + 1, label: idx + 1}))
                        .map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                    </select>

                    <button
                      className="rev-btn primary"
                      onClick={onMintClick}
                      disabled={inputDisabled}>
                      <div>Mint</div>
                    </button>
                  </CurrMintTime>
                </>
              )}

              {txHash && (
                <div className="tx-hash">
                  <div>交易已成功送出!</div>
                  <a href={'/#'}>{txHash}</a>
                </div>
              )}
            </div>
          </div>
        </HeroSection>
      )}

      <Footer />
    </Wrapper>
  );
  */
}

class InputNumber extends React.Component {
  state = {
    value: 1,
  };

  constructor() {
    super();

    this.increment = this.increment.bind(this);
    this.decrement = this.decrement.bind(this);
  }

  get value() {
    return this.state.value;
  }

  increment() {
    const {min, max} = this.props;

    if (this.value >= max) {
      this.setState({value: min});
      this.props.onChange(min);
    } else {
      this.setState({value: this.value + 1});
      this.props.onChange(this.value + 1);
    }
  }

  decrement() {
    const {min, max} = this.props;

    if (this.value <= min) {
      this.setState({value: max});
      this.props.onChange(max);
    } else {
      this.setState({value: this.value - 1});
      this.props.onChange(this.value - 1);
    }
  }

  render() {
    return (
      <div className="input-number" style={this.props.style}>
        <button type="button" onClick={this.decrement}>
          &minus;
        </button>
        <span>{this.value}</span>
        <button type="button" onClick={this.increment}>
          &#43;
        </button>
      </div>
    );
  }
}

const Wrapper2 = styled.div`
  & ul {
    color: white;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  min-height: 100vh;
  background-color: ${Constants.themeColor};

  &#mint-page {
    @media (max-width: 720px) {
      & .content > * {
        flex-basis: auto;
      }
    }
  }
`;

const HeroSection = styled(BaseSection)`
  & > .content {
    & > div {
      flex: 1 1 300px;
      align-items: center;

      & h2 {
        font-size: 3.5rem;
        line-height: 3.5rem;
        color: white;
      }

      & select {
        width: 120px;
        margin-bottom: 10px;
      }

      & .tx-hash {
        margin-top: 10px;
        color: white;
        text-align: center;
      }
    }

    & > figure {
      flex: 1 0 300px;
      & img {
        width: 100%;
        object-fit: contain;
        overflow: hidden;
        border-radius: 20px;
      }
    }
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #009ea9;
  width: 100%;
  padding: 25px 20%;

  .input-number {
    position: relative;
    width: 100px;
    height: 40px;
    background-color: transparent;
    overflow: hidden;
    border-radius: 20px;
    margin: 2px;
  }

  .input-number span {
    position: absolute;
    left: 50%;
    margin-left: -20px;
    display: inline-block;
    background-color: white;
    height: 100%;
    width: 40px;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 16px;
    color: #6c6dff;
    letter-spacing: -1px;
  }

  .input-number button {
    display: inline-block;
    width: 50px;
    height: 100%;
    background-color: transparent;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.2);
    transition: background-color 0.2s ease;
  }

  .input-number button:nth-of-type(1) {
    padding-right: 20px;
  }

  .input-number button:nth-of-type(2) {
    padding-left: 20px;
  }

  .input-number button:hover {
    background-color: rgba(255, 255, 255, 0.25);
  }
`;

export default MintPage;
